import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './cardCarousel.css';

const CardCarousel = () => {
  const [cards, setCards] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    const fetchCards = async () => {
      try {
        const carouselUrl = process.env.REACT_APP_MASTERMIND_CAROUSEL_JSON
          || `${process.env.REACT_APP_CDN_LINK}mastermind/homepage/mastermindsCarousel.json`;
        const response = await fetch(`${carouselUrl}?t=${Date.now()}`);
        const data = await response.json();
        console.log('Carousel data loaded:', data.length, 'cards');
        setCards(data);
      } catch (error) {
        console.error('Error fetching card data:', error);
      }
    };

    fetchCards();
  }, []);

  const filteredCards = cards.filter(card =>
    card.subheading && card.subheading.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const uniqueFilteredCards = [];
  const seenSubheadings = new Set();

  filteredCards.forEach(card => {
    const subheading = card.subheading.toLowerCase();
    if (!seenSubheadings.has(subheading)) {
      uniqueFilteredCards.push(card);
      seenSubheadings.add(subheading);
    }
  });

  console.log('Cards:', cards.length, 'Filtered:', filteredCards.length, 'Unique:', uniqueFilteredCards.length);

  const settings = {
    dots: false,
    arrows: false,
    infinite: uniqueFilteredCards.length > 1,
    speed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: uniqueFilteredCards.length > 1,
    autoplaySpeed: 0,
    cssEase: 'linear',
    pauseOnHover: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: uniqueFilteredCards.length > 1,
          dots: false,
          arrows: false,
          autoplay: uniqueFilteredCards.length > 1
        }
      }
    ]
  };

  const renderCard = (card, index) => (
    <div
      className="carousel-card"
      key={index}
      onClick={() => window.open(card.link, '_self')}
      style={{ cursor: 'pointer' }}
    >
      <div
        className="card-background"
        style={{ backgroundImage: `url(${card.backgroundImage})` }}
      >
        <h1 className="card-heading">Masterminds</h1>
        <p className="card-subheading">{card.subheading}</p>
        <img src={card.smallImage} alt="small" className="card-small-image" />
      </div>
    </div>
  );

  return (
    <div className="carousel-container">
      <div className="search-container">
        <input
          type="text"
          placeholder="Search"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="search-input"
        />
        <i className="fas fa-search search-icon"></i>
      </div>
      {uniqueFilteredCards.length > 1 ? (
        <Slider {...settings}>
          {uniqueFilteredCards.map((card, index) => renderCard(card, index))}
        </Slider>
      ) : uniqueFilteredCards.length === 1 ? (
        <div className="single-card-container">
          {renderCard(uniqueFilteredCards[0], 0)}
        </div>
      ) : (
        <p>No results found</p>
      )}
    </div>
  );
};

export default CardCarousel;
